var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{},[(_vm.value)?_c('i',{staticClass:"bi bi-check-lg text-success"}):_c('i',{staticClass:"bi bi-x-lg text-danger"})])
}
var staticRenderFns = []

export { render, staticRenderFns }